webpackJsonp([160613607529204],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FaqQuery = undefined;
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles() {
	  return {
	    page: {
	      height: "100%",
	      width: "100%"
	    },
	    container: {
	      width: "100%",
	      paddingBottom: "2rem"
	    },
	    text: {
	      paddingLeft: "5rem",
	      paddingRight: "5rem",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        marginLeft: "1rem",
	        marginRight: "1rem",
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "4.5rem",
	        fontWeight: 200,
	        margin: 0,
	        "@media (max-width: 823px)": {
	          fontSize: "3rem",
	          textAlign: "center"
	        }
	      },
	      "& h4": {
	        fontWeight: 400,
	        "@media (max-width: 823px)": {
	          fontSize: "1.5rem"
	        }
	      }
	    }
	  };
	};
	
	var FaqPage = function FaqPage(_ref) {
	  var data = _ref.data,
	      classes = _ref.classes;
	  return _react2.default.createElement(
	    _ContentBlock2.default,
	    { className: classes.page },
	    _react2.default.createElement(
	      "div",
	      { className: classes.container },
	      _react2.default.createElement(
	        _TextSection2.default,
	        { className: classes.text },
	        _react2.default.createElement(_HtmlContainer2.default, { content: data.MainContent.html })
	      )
	    )
	  );
	};
	
	FaqPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(FaqPage);
	
	/* global graphql */
	
	var FaqQuery = exports.FaqQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-jsx-5b609e575c794a97d0e8.js